import { Commit } from "vuex";

export default {
    updateStatus({ commit }:{commit:Commit}, status:number) {
        commit("setStatus", status);
    },
};
